import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockSenateTrading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getSenateTrading(this.state.symbol, this.state.limit).then(result => {
            console.log('Senate Trading', result);
            let filteredData = [];
            let length = this.state.limit === undefined ? 200 : this.state.limit;
            if (result.length > 0) {
                length = result.length < length ? result.length : length;
                for (var i = 0; i < length; i++) {
                    filteredData.push(result[i]);
                }
            }
            this.setState({ list: filteredData });
        })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        let resultColor = '';
        if (listValue.type.toLowerCase().startsWith('sale')) {
            resultColor = 'red';
        } else if (listValue.type.toLowerCase().startsWith('purchase')) {
            resultColor = 'green';
        }

        return (
            <tr key={listValue.publishedDate + listValue.representative + Math.random()} style={{ color: resultColor }}>
                <td style={{ color: resultColor, width: '12%'}}>{listValue.transactionDate.split('T')[0]}</td>
                <td style={{ color: resultColor}}>{listValue.firstName} {listValue.lastName}</td>
                <div><a href={listValue.link} target="_blank" rel="noreferrer" style={{ color: resultColor}}>{listValue.assetDescription}</a></div>
                <td style={{ color: resultColor}}>{this.capitalizeFirstLetter(listValue.type)}</td>
                <td style={{ color: resultColor}}>{listValue.amount}</td>
            </tr>
        )
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }

        let header = 'Senate Trading';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/stockSenateTrading/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/stockGrade/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }

        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Representative</th>
                            <th>Link</th>
                            <th>Type</th>
                            <th>Amount&nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Senate Trading disclosure on buying/selling the stocks<br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockSenateTrading;
